import React from 'react';
import '../css/Home.css';
import ProductList from './ProductList';
import useScrollRestoration from './useScrollRestoration';



const Home = () => {
  useScrollRestoration();
  return (
    <div className="home-container">
      {/* Hero Section */}
      <section className="hero-section">
        <h1>Welcome to MechArtista Technocrafts</h1>
        <p>Your destination for innovative technology solutions.</p>
        <button className="explore-btn">Explore More</button>
      </section>

      {/* Additional Sections */}
      <section className="features-section">
        <div className="feature-box">
          <h3>Innovative Designs</h3>
          <p>We craft unique and efficient solutions tailored to your needs.</p>
        </div>
        <div className="feature-box">
          <h3>Advanced Technology</h3>
          <p>Stay ahead with our cutting-edge technologies and services.</p>
        </div>
        <div className="feature-box">
          <h3>Expert Support</h3>
          <p>Our team is here to support you every step of the way.</p>
        </div>
      </section>
      <ProductList />
    </div>
  );
};

export default Home;
